import { environment } from "@environments/environment";

export function getWhiteLabelConfig(): WhiteLabelConfig {
    const currentDomain = window.location.origin;
    for (const config of Object.values(whiteLabels)) {
      if (config.domains.includes(currentDomain)) {
        return config;
      }
    }

    // Default configuration
    return {
      domains: [],
      backgroundColor:
        environment.validatorHeaderLookAndFeel.default.backgroundColor,
      actionsBackgroundColor:
        environment.validatorHeaderLookAndFeel.default.actionsBackgroundColor,
      logoUrl: environment.validatorHeaderLookAndFeel.default.logoUrl,
      validatorHome: DEFAULT_VALIDATOR_HOME,
    };
  }

  interface WhiteLabelConfig {
    domains: string[];
    backgroundColor: string;
    actionsBackgroundColor: string;
    logoUrl: string;

    /**
     * Ruta de inicio del validador para este dominio.
     *
     * Las aseguradoras entran por el validador de fianzas, cuya tarjeta de XML salta al modulo
     * generico. Sin este dato los botones de regreso de ese modulo estaban clavados a `/validator`
     * y devolvian al inicio equivocado: el mismo lugar, pero con el validador de codigo generico en
     * lugar del de fianzas.
     *
     * Se resuelve por dominio, igual que el logotipo y los colores, y no por historial de
     * navegacion: al validador se llega por enlace directo, y ahi no hay historial al cual volver.
     */
    validatorHome: string;
  }

  /**
   * Inicio del validador cuando el dominio no tiene marca propia.
   */
  const DEFAULT_VALIDATOR_HOME = '/validator';

  /**
   * Inicio del validador para las aseguradoras que consultan fianzas y seguros.
   */
  const SURETY_VALIDATOR_HOME = '/surety-validator';
  
  const whiteLabels: Record<string, WhiteLabelConfig> = {
    aserta: {
      domains: environment.validatorHeaderLookAndFeel.Aserta.domains,
      backgroundColor:
        environment.validatorHeaderLookAndFeel.Aserta.backgroundColor,
      actionsBackgroundColor:
        environment.validatorHeaderLookAndFeel.Aserta.actionsBackgroundColor,
      logoUrl: environment.validatorHeaderLookAndFeel.Aserta.logoUrl,
      validatorHome: SURETY_VALIDATOR_HOME,
    },
    insurgentes: {
      domains: environment.validatorHeaderLookAndFeel.Insurgentes.domains,
      backgroundColor:
        environment.validatorHeaderLookAndFeel.Insurgentes.backgroundColor,
      actionsBackgroundColor:
        environment.validatorHeaderLookAndFeel.Insurgentes.actionsBackgroundColor,
      logoUrl: environment.validatorHeaderLookAndFeel.Insurgentes.logoUrl,
      validatorHome: SURETY_VALIDATOR_HOME,
    },
  };